import { type SvgIconProps } from '@common/components/svgs/props';

function IconRecycleBin(
  { size = 16, color = 'scheme-feedback-text-color', ...rest }: Readonly<SvgIconProps>,
) {
  return (
    <svg
      {...rest}
      height={size}
      width={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="svg-RecycleBin"
    >
      <path d="M8 5H16V3H8V5Z" fill={`var(--${color})`} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 8H18.926L18.2782 16.4218C18.2306 17.0402 18.1905 17.5618 18.1236 17.9882C18.0534 18.4356 17.9433 18.8575 17.7136 19.2542C17.3615 19.862 16.8347 20.3499 16.2016 20.6543C15.7885 20.853 15.3594 20.9304 14.908 20.966C14.4777 21 13.9546 21 13.3343 21H10.6658C10.0455 21 9.5223 21 9.09199 20.966C8.6406 20.9304 8.21148 20.853 7.79833 20.6543C7.16527 20.3499 6.63845 19.862 6.28639 19.2542C6.05663 18.8575 5.94653 18.4356 5.87635 17.9882C5.80945 17.5618 5.76934 17.0402 5.72178 16.4217L5.07395 8H3V6H21V8ZM7.07986 8H16.9201L16.287 16.2301C16.2357 16.8969 16.201 17.3392 16.1478 17.6783C16.0965 18.0052 16.0387 18.1554 15.9829 18.2518C15.832 18.5123 15.6062 18.7214 15.3349 18.8518C15.2345 18.9001 15.0804 18.9462 14.7504 18.9722C14.4083 18.9993 13.9647 19 13.2959 19H10.7041C10.0353 19 9.59169 18.9993 9.24952 18.9722C8.91957 18.9462 8.76543 18.9001 8.66504 18.8518C8.39372 18.7214 8.16794 18.5123 8.01706 18.2518C7.96123 18.1554 7.90348 18.0052 7.85219 17.6783C7.79899 17.3392 7.76424 16.8969 7.71294 16.2301L7.07986 8Z"
        fill={`var(--${color})`}
      />
    </svg>
  );
}

IconRecycleBin.displayName = 'Recycle-Bin';

export default IconRecycleBin;
